/**
 * RPC Service - Default Implementation
 *
 * Wraps the real rpc function for DI injection.
 * This allows services to depend on IRpcService interface
 * rather than directly importing the rpc function.
 */

import { rpc } from "../rpc";
import type { IRpcService } from "./types";

/**
 * Default RPC service implementation.
 * Delegates to the real rpc function from rpc.ts.
 */
export class RpcService implements IRpcService {
  async call<T = unknown>(name: string, params: unknown): Promise<T> {
    // Cast to bypass strict typing - the real rpc function handles validation
    return rpc(name as never, params as never) as Promise<T>;
  }
}
